<template>
    <div>
        <div class="table-scroller">
            <table>
                <thead>
                <tr>
                    <th class="w-7/12">{{text.headline}}</th>
                    <th class="w-3/12">{{text.published}}</th>
                    <th class="w-2/12">{{text.actions}}</th>
                </tr>
                </thead>
                <tbody v-if="activeTableData.length > 0">
                <tr v-for="row in activeTableData" :key="row.id">
                    <td><router-link :to="{ name: 'AdminMessagesEdit', params: { 'id' : row.id } }" :title="text.edit + ' ' + row.headline" class="default-action">{{row.headline}}</router-link></td>
                    <td class="table-meta">{{row.messageDate | formatDate}}</td>
                    <td>
                        <ViewAction :routeName="'AdminMessagesView'" :routeParams="{ 'id' : row.id }" :linkName="row.headline" />
                        <EditAction :routeName="'AdminMessagesEdit'" :routeParams="{ 'id' : row.id }" :linkName="row.headline" />
                        <DeleteAction :linkName="row.headline" @actionCalled="archiveMessage(row.id, 'messageArchived')"  />
                    </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="3">{{text.no_results}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <Pagination v-if="activeTablePagination.totalPages > 0" :pagination="activeTablePagination" @go-previous="refreshMessagesList" @go-next="refreshMessagesList" />
    </div>
</template>

<script>
    import lang from "@/shared/lang";
    import {MESSAGE_TYPE_SUCCESS} from "@/shared/consts";

    import {formatContentMixin} from "@/views/mixins/formatContent";
    import {messagesActionsMixin} from "@/views/mixins/messagesActions";

    import Pagination from "@/components/pagination";
    import EditAction from "@/components/actionlinks/edit";
    import ViewAction from "@/components/actionlinks/view";
    import DeleteAction from "@/components/actionlinks/delete";

    export default {
        name: 'AdminMessagesList',
        components: {Pagination, ViewAction, EditAction, DeleteAction},
        mixins: [formatContentMixin,messagesActionsMixin],
        data() {
            return {
                activeTableData: [],
                activeTablePagination: [],
            }
        },
        computed: {
            text() {
                return lang;
            },
            message() {
                return this.$route.params.message
            }
        },
        methods: {
            async refreshMessagesList(page = 1){
                await this.loadAdminActiveMessagesList(page);
            },
            showMessage() {
                if(this.message === "saved"){
                    this.$store.dispatch('addSystemMessageAction', {
                        'type' : MESSAGE_TYPE_SUCCESS,
                        'message' : lang.message_message_edit_saved
                    });
                }
                else if(this.message === "added"){
                    this.$store.dispatch('addSystemMessageAction', {
                        'type' : MESSAGE_TYPE_SUCCESS,
                        'message' : lang.message_message_added
                    });
                }
            },
            messageDeleted(){
                this.$store.dispatch('addSystemMessageAction', {
                    'type' : MESSAGE_TYPE_SUCCESS,
                    'message' : lang.message_message_deleted
                });
                this.refreshMessagesList(1);
            },
            messageArchived(){
                this.$store.dispatch('addSystemMessageAction', {
                    'type' : MESSAGE_TYPE_SUCCESS,
                    'message' : lang.message_message_archived
                });
                this.refreshMessagesList(1);
            }
        },
        async mounted() {
            this.refreshMessagesList(1);
            this.showMessage();
        }
    }
</script>
